import React, { Component } from "react"
import SimpleBar from "simplebar-react"
import { connect } from "react-redux"
import MetisMenu from "metismenujs"
import { NavLink } from "react-router-dom"
import { toggleSideMenu } from "../../store/common/commonActions"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0] // 'swordsofblood', 'localhost', 'app'

//is necessary to get this below info from an api
//getTabs(subdomain)
//turn tabs + tab contents into html

class SidebarContent extends Component {
    constructor(props) {
        super(props)
        this.refDiv = React.createRef()
    }

    componentDidMount() {
        this.initMenu()
    }

    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps, prevState, ss) {
        if (this.props.type !== prevProps.type) {
            this.initMenu()
        }
    }

    initMenu() {
        new MetisMenu("#side-menu")

        let matchingMenuItem = null
        const ul = document.getElementById("side-menu")
        const items = ul.getElementsByTagName("a")
        // for (let i = 0; i < items.length; ++i) {
        //   if (this.props.location.pathname === items[i].pathname) {
        //     matchingMenuItem = items[i]
        //     break
        //   }
        // }
        // if (matchingMenuItem) {
        //   this.activateParentDropdown(matchingMenuItem)
        // }
    }

    scrollElement = (item) => {
        setTimeout(() => {
            if (this.refDiv.current !== null) {
                if (item) {
                    const currentPosition = item.offsetTop
                    if (currentPosition > window.innerHeight) {
                        if (this.refDiv.current) this.refDiv.current.getScrollElement().scrollTop = currentPosition - 300
                    }
                }
            }
        }, 300)
    }

    activateParentDropdown = (item) => {
        item.classList.add("active")
        const parent = item.parentElement

        const parent2El = parent.childNodes[1]
        if (parent2El && parent2El.id !== "side-menu") {
            parent2El.classList.add("mm-show")
        }

        if (parent) {
            parent.classList.add("mm-active")
            const parent2 = parent.parentElement

            if (parent2) {
                parent2.classList.add("mm-show") // ul tag

                const parent3 = parent2.parentElement // li tag

                if (parent3) {
                    parent3.classList.add("mm-active") // li
                    parent3.childNodes[0].classList.add("mm-active") //a
                    const parent4 = parent3.parentElement // ul
                    if (parent4) {
                        parent4.classList.add("mm-show") // ul
                        const parent5 = parent4.parentElement
                        if (parent5) {
                            parent5.classList.add("mm-show") // li
                            parent5.childNodes[0].classList.add("mm-active") // a tag
                        }
                    }
                }
            }
            this.scrollElement(item)
            return false
        }
        this.scrollElement(item)
        return false
    }

    onClickMenuItem = () => {
        if (window.innerWidth < 992) {
            this.props.toggleSideMenu(false)
        }
    }

    renderTabs = () => {
        if (subdomain === "swordsofblood") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Home</li>
                        <li>
                            <NavLink to="/" className="waves-effect" onClick={this.onClickMenuItem} exact activeClassName="waves-active">
                                <i className="bx bx-home-circle"></i>
                                <span>Dashboard</span>
                            </NavLink>
                        </li>
                        <li className="menu-title">Community</li>

                        <li className="li-nft_profile">
                            <NavLink to="/profile" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-user"></i>
                                <span>Profile</span>
                            </NavLink>
                        </li>

                        <li className="li-nft_sale">
                            <NavLink to="/nftsale" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-money"></i>
                                <span>NFT Sale</span>
                            </NavLink>
                        </li>
                        <li className="li-token_gating">
                            <NavLink to="/tokengating" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-check-double"></i>
                                <span>Token Gating</span>
                            </NavLink>
                        </li>
                        <li className="li-token_gating">
                            <NavLink to="/vesting" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-box"></i>
                                <span>Token Locker</span>
                            </NavLink>
                        </li>
                        <li className="li-token_gating">
                            <NavLink to="/stakingsob" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>Staking</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else if (subdomain === "bridge") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Community</li>

                        <li className="li-bridge">
                            <NavLink to="/bridge" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-transfer"></i>
                                <span>Bridge</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else if (subdomain === "zkc") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Community</li>

                        <li className="li-zkc">
                            <NavLink to="/zkcmint" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-transfer"></i>
                                <span>zkCompanion</span>
                            </NavLink>
                        </li>
                        <li className="li-profile">
                            <NavLink to="/profile" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-transfer"></i>
                                <span>Profile</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else if (subdomain === "artcontest") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Art Contest</li>

                        <li className="li-zkc">
                            <NavLink to="/zkmintnft" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-paint"></i>
                                <span>Mint Art NFT</span>
                            </NavLink>
                        </li>
                        <li className="li-zkc">
                            <NavLink to="/zkviewnft" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-image"></i>
                                <span>View Art NFTs</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else if (subdomain === "ideas") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Idea Markeplace</li>

                        <li className="li-zkc">
                            <NavLink to="/ideaviewer" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-paint"></i>
                                <span>View and Vote</span>
                            </NavLink>
                        </li>
                        <li className="li-zkc">
                            <NavLink to="/ideamint" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-image"></i>
                                <span>Create New Idea</span>
                            </NavLink>
                        </li>
                        <li className="li-staking">
                            <NavLink to="/staking" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>Staking</span>
                            </NavLink>
                        </li>
                        <li className="li-staking">
                            <NavLink to="/nodeprestaking" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>L3 Node Pre-Staking</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else if (subdomain === "app") {
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Home</li>
                        <li>
                            <NavLink to="/" className="waves-effect" onClick={this.onClickMenuItem} exact activeClassName="waves-active">
                                <i className="bx bx-home-circle"></i>
                                <span>Dashboard</span>
                            </NavLink>
                        </li>
                        <li className="li-staking">
                            <NavLink to="/nodeprestaking" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>L3 Node Pre-Staking</span>
                            </NavLink>
                        </li>
                        <li className="menu-title">Community</li>
                        <li className="li-vesting">
                            <NavLink to="/token" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-box"></i>
                                <span>Vesting</span>
                            </NavLink>
                        </li>
                        <li className="li-staking">
                            <NavLink to="/staking" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>Staking</span>
                            </NavLink>
                        </li>
                        <li className="li-bridge">
                            <NavLink to="/bridge" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-transfer"></i>
                                <span>Bridge</span>
                            </NavLink>
                        </li>
                        <li className="li-voting">
                            <NavLink to="/voting" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-upvote"></i>
                                <span>Voting</span>
                            </NavLink>
                        </li>

                        <li className="li-nft_profile">
                            <NavLink to="/profile" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-user"></i>
                                <span>Profile</span>
                            </NavLink>
                        </li>
                        <li className="li-nft_trading">
                            <NavLink to="/trading" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-store"></i>
                                <span>NFT Trading</span>
                            </NavLink>
                        </li>
                        <li className="li-token_gating">
                            <NavLink to="/tokengating" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-check-double"></i>
                                <span>Token Gating</span>
                            </NavLink>
                        </li>
                        <li className="li-tasks">
                            <NavLink to="/tasks" className="waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-task"></i>
                                <span>Tasks</span>
                            </NavLink>
                        </li>

                        <li className="menu-title">Settings</li>
                        <li className="li-account">
                            <NavLink to="/settings" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-cog"></i>
                                <span>Account</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        } else {
            // local host, or another subdomain
            return (
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li className="menu-title">Home</li>
                        <li>
                            <NavLink to="/" className="waves-effect" onClick={this.onClickMenuItem} exact activeClassName="waves-active">
                                <i className="bx bx-home-circle"></i>
                                <span>Dashboard</span>
                            </NavLink>
                        </li>
                        <li className="li-staking">
                            <NavLink to="/nodeprestaking" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-building"></i>
                                <span>L3 Node Pre-Staking</span>
                            </NavLink>
                        </li>
                        <li className="menu-title">Community</li>

                        <li className="li-nft_profile">
                            <NavLink to="/profile" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-user"></i>
                                <span>Profile</span>
                            </NavLink>
                        </li>

                        <li className="li-token_gating">
                            <NavLink to="/tokengating" className=" waves-effect" onClick={this.onClickMenuItem} activeClassName="waves-active">
                                <i className="bx bx-check-double"></i>
                                <span>Token Gating</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    render() {
        return (
            <React.Fragment>
                <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
                    {this.renderTabs()}
                </SimpleBar>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = {
    toggleSideMenu
}

export default connect(null, mapDispatchToProps)(SidebarContent)
